import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IErrorResponse, QueryKeys } from "../../querys/querys.enum";
import axiosInstance from "../../../utils/axios";
import {
  NotificationKeysValuesParams,
  NotificationKeysValuesResponse,
} from "../../../models/Interface/NotificationManagement.interface";

/**
 * GET /notifications-management/keys-values — permission: `get:notification:keys:values`
 *
 * Returns one entry per key set, so a rotating type yields one entry per
 * variant. Always refetched on a language/type change (`staleTime: 0`) —
 * this is the QA surface for missing localizations.
 */
const useNotificationKeysValues = (
  params: NotificationKeysValuesParams,
  enabled = true
) => {
  return useQuery<NotificationKeysValuesResponse, AxiosError<IErrorResponse>>({
    queryKey: [QueryKeys.NOTIFICATION_KEYS_VALUES, params],
    queryFn: async () => {
      const search = new URLSearchParams({
        interfaceLanguage: params.interfaceLanguage,
      });
      if (params.notificationType) {
        search.append("notificationType", params.notificationType);
      }

      return (
        await axiosInstance.get(
          `/notifications-management/keys-values?${search.toString()}`
        )
      ).data;
    },
    enabled: enabled && !!params.interfaceLanguage,
    staleTime: 0,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    retry: 0,
  });
};

export default useNotificationKeysValues;
